import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Stack, Typography } from "@mui/material";

import HomePageCard from "../HomePageCard";

export const CreateItemCard = ({
  createMsg,
  buttonLabel,
  title,
  onButtonClick,
  buttonDataCy,
}: {
  createMsg: string;
  buttonLabel: string;
  title: string | React.ReactNode;
  onButtonClick: () => void;
  buttonDataCy: string;
}) => {
  const history = useHistory();

  return (
    <HomePageCard title={title}>
      <Stack direction="column" spacing={2} sx={{ p: 3, height: 161 }}>
        <Typography
          variant="caption"
          color="text.primary"
          sx={{ textTransform: "lowercase", "&:first-letter": { textTransform: "capitalize" } }}
        >
          {createMsg}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          endIcon={<ArrowForwardIcon />}
          onClick={onButtonClick}
          data-cy={buttonDataCy}
        >
          {buttonLabel}
        </Button>
        <Button
          variant="text"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          data-cy="get-help-btn"
          onClick={() => {
            history.push("./support?open-case-iq=true");
          }}
        >
          Get help from our human experts
        </Button>
      </Stack>
    </HomePageCard>
  );
};
